import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpText } from 'Wpds/components/text';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';

// Styles
import './PiSuggestedTopicsEmptyState.scss';

type Props = {
  title: string;
  description: string;
  actions: React.ReactNode;
};

const PiSuggestedTopicsEmptyState = ({ title, description, actions }: Props) => {
  const baseClassName = 'PiSuggestedTopicsEmptyState';

  return (
    <WpContainer color="gray" className={baseClassName}>
      <WpContainerBody>
        <WpText bold variant="bodyLg">
          {title}
        </WpText>
        <WpContainer className={`${baseClassName}__example`}>
          <WpContainerBody>
            <div className={`${baseClassName}__example__text`}>
              <WpText noMargin>
                <WpText bold noMargin tag="span">
                  Example:&nbsp;
                </WpText>
                What are you excited to talk about today?
              </WpText>
            </div>
            <div className={`${baseClassName}__example__based-on`}>
              <WpText bold noMargin variant="bodyXs" color="gray-600">
                Based On:
              </WpText>
              <WpIllustration src={Illustrations.reference_profile_persuader} width="18px" />
              <WpText noMargin variant="bodyXs" color="gray-600">
                Aliza’s high level of enthusiasm
              </WpText>
            </div>
          </WpContainerBody>
        </WpContainer>
        <WpText variant="bodyMd" color="gray-600">
          {description}
        </WpText>
        {actions}
      </WpContainerBody>
    </WpContainer>
  );
};

export default PiSuggestedTopicsEmptyState;
